// extracted by mini-css-extract-plugin
export var btn = "banner-module--btn--PO-5d";
export var btnBlock = "banner-module--btnBlock--Gx8Gh";
export var container = "banner-module--container--Kfw3m";
export var hideMobBlock = "banner-module--hideMobBlock--GAFp-";
export var img = "banner-module--img--q8ZM3";
export var mobBtn = "banner-module--mobBtn--qvKQT";
export var secondContainer = "banner-module--secondContainer--0Q-zt";
export var stickyContain = "banner-module--stickyContain--Xulc9";
export var text = "banner-module--text--3KE87";